import "../libraries/jquery.scrollTo.min";

export default function GoToTabById(id) {
  $('#' + id).find('span').trigger('click');
  $.scrollTo('#category-tabs', 300, { offset: -200 });

  return false;
}